import React from 'react';
import styles from './ValidationMessage.module.scss';
import { isNullOrUndefined } from '../../helpers/object-helpers';
import ExclamationTriangle from '../Icons/ExclamationTriangle';
import CheckCircle from '../Icons/CheckCircle';

export interface IErrorMessage {
  // undefined - not validated, false - invalid, true - valid
  // It will be more clear to use an enum here
  isValid?: boolean;
  errors?: Array<string | undefined>;
  validText?: string;
}

export default function ValidationMessage({ isValid, errors, validText }: IErrorMessage) {
  if (isValid === undefined) {
    return null;
  }

  if (isValid) {
    if (isNullOrUndefined(validText) || validText === '') {
      return null;
    }

    return (
      <div className={styles['validation-message']}>
        <div className={styles.valid}>
          <CheckCircle />
          {validText}
        </div>
      </div>
    );
  }

  return (
    <div className={styles['validation-message']}>
      <small role="alert" className={styles.error}>
        {errors?.map((error, index) => (
          <React.Fragment key={index}>
            <ExclamationTriangle />
            {error}
          </React.Fragment>
        ))}
      </small>
    </div>
  );
}
